<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="detailsContent">
      <News :type="type" pageType="add"></News>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import News from "@/components/news";
export default {
  data() {
    return {
      navBlock: "新聞  /  新聞列表",
      navtitle: "新增新聞",
      type: "add",
    };
  },
  components: {
    NavBar,
    News,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/news/news/addNews.vue